<template>
  <app-layout>
    <!-- <app-stepper :scaffold="scaffold" :current="0" /> -->

    <div class="max-w-screen-xl mx-auto px-5">
      <el-breadcrumb class="my-5 w-full" separator="/">
        <el-breadcrumb-item
          :to="{ name: 'builder', params: { scaffoldId } }"
        >
          Entities
        </el-breadcrumb-item>
        <el-breadcrumb-item class="b">{{
          entity && entity.name && entity.name.singular
            ? entity.name.singular
            : 'New Entity'
        }}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-tabs
        class="shadow-none"
        v-model="tab"
        type="border-card"
      >
        <el-tab-pane name="basic" label="Basic">
          <app-entity-form-basic></app-entity-form-basic>
        </el-tab-pane>
        <el-tab-pane
          v-if="fieldEnabled"
          name="field"
          label="Fields"
        >
          <app-field-list></app-field-list>
        </el-tab-pane>
        <el-tab-pane
          v-if="propertyEnabled"
          name="property"
          label="Properties"
        >
          <app-entity-form-property></app-entity-form-property>
        </el-tab-pane>
      </el-tabs>

      <app-builder-debugger
        v-if="debugging"
        :data="entity"
      ></app-builder-debugger>

      <div class="my-4">
        <el-button type="primary" @click="save()"
          >Save</el-button
        >
        <router-link
          class="el-button"
          :to="{ name: 'builder', params: { scaffoldId } }"
          >Cancel</router-link
        >
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-entity-form',

  props: ['scaffoldId', 'id', 'routedTab', 'reload'],

  created() {
    if (!this.$store.getters['scaffold/current']) {
      this.$router.push({
        name: 'builder',
        params: { scaffoldId: this.scaffoldId },
      });
      return;
    }

    const create = !this.id;

    if (create) {
      this.$store.dispatch('builder/entityCurrent/new');
    } else {
      const entity = this.$store.getters[
        'builder/entityCurrent/get'
      ](this.id, !!this.reload);

      if (entity) {
        this.$store
          .dispatch('builder/entityCurrent/edit', entity)
          .then(() => {
            if (this.routedTab) {
              this.$store.commit(
                'builder/entityCurrent/tab',
                this.routedTab,
              );
            }
          });
      } else {
        this.$router.push({
          name: 'builder',
          params: { scaffoldId: this.scaffoldId },
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      debugging: 'builder/debugging',
      entity: 'builder/entityCurrent/current',
    }),

    tab: {
      get() {
        return this.$store.state.builder.entityCurrent.tab;
      },
      set(value) {
        this.$store.commit(
          'builder/entityCurrent/tab',
          value,
        );
      },
    },

    propertyEnabled() {
      return this.$store.getters[
        'builder/entityProperty/enabled'
      ]();
    },

    fieldEnabled() {
      return this.$store.getters['builder/field/enabled'];
    },
  },

  methods: {
    save() {
      const { dispatch } = this.$store;

      dispatch('builder/entityCurrent/save')
        .then(() => {
          this.$router.push({
            name: 'builder',
            params: { scaffoldId: this.scaffoldId },
          });
        })
        .catch(() => {
          // ignore, it is a validation error
        });
    },
  },
};
</script>

<style></style>
